const EMOJI_PATTERN = /\p{Extended_Pictographic}|\uFE0F|\u200D|\u20E3/gu;

export function removeEmojis(value: string): string {
  return value.replace(EMOJI_PATTERN, '');
}
